import script from "./componentTemplate.vue?vue&type=script&lang=js"
export * from "./componentTemplate.vue?vue&type=script&lang=js"

import "./componentTemplate.vue?vue&type=style&index=0&id=0112af73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0112af73"]])

export default __exports__